export default "__VITE_ASSET__BuK4i3j5__"